import { PERMISSIONS } from './features.js';
export const SYSTEM_DATA_OBJECT_KEYS = ['client', 'deal', 'contact', 'action_item', 'product'];
/** The shared icon-picker vocabulary used by Data Model tools and surfaces. */
export const DATA_OBJECT_ICON_NAMES = [
    'ArchiveBoxIcon', 'BanknotesIcon', 'BeakerIcon', 'BoltIcon', 'BookOpenIcon',
    'BriefcaseIcon', 'BuildingOffice2Icon', 'CalculatorIcon', 'CalendarDaysIcon',
    'CameraIcon', 'ChartBarIcon', 'ChatBubbleLeftRightIcon', 'CheckCircleIcon',
    'CircleStackIcon', 'ClipboardDocumentCheckIcon', 'ClockIcon', 'Cog6ToothIcon',
    'CreditCardIcon', 'CubeIcon', 'CurrencyDollarIcon', 'DocumentTextIcon',
    'EnvelopeIcon', 'ExclamationTriangleIcon', 'EyeIcon', 'FireIcon', 'FlagIcon',
    'FolderIcon', 'GlobeAltIcon', 'HeartIcon', 'HomeIcon', 'IdentificationIcon',
    'KeyIcon', 'LinkIcon', 'ListBulletIcon', 'LockClosedIcon', 'MagnifyingGlassIcon',
    'MapPinIcon', 'MegaphoneIcon', 'NewspaperIcon', 'PencilSquareIcon', 'PhoneIcon',
    'PhotoIcon', 'PuzzlePieceIcon', 'RocketLaunchIcon', 'ServerIcon',
    'ShieldCheckIcon', 'ShoppingCartIcon', 'SparklesIcon', 'StarIcon',
    'TableCellsIcon', 'TagIcon', 'TicketIcon', 'TrashIcon', 'TruckIcon',
    'UserCircleIcon', 'UserGroupIcon', 'UsersIcon', 'WalletIcon', 'WrenchIcon',
];
/** Typed constants for system data object keys - use these instead of string literals */
export const OBJECT_KEYS = {
    CLIENT: 'client',
    DEAL: 'deal',
    CONTACT: 'contact',
    ACTION_ITEM: 'action_item',
    PRODUCT: 'product',
};
/** Default labels for system data objects - used as fallbacks when store hasn't loaded */
export const DEFAULT_OBJECT_LABELS = {
    client: { singular: 'Client', plural: 'Clients' },
    deal: { singular: 'Deal', plural: 'Deals' },
    contact: { singular: 'Contact', plural: 'Contacts' },
    action_item: { singular: 'Action Item', plural: 'Action Items' },
    product: { singular: 'Product', plural: 'Products' },
};
export const RelationCardinality = {
    ONE: 'one',
    MANY: 'many',
};
/** How a Quick Command should handle an optional relationship. */
export const QuickCommandRelationshipMode = {
    AUTO_BIND: 'auto_bind',
    INHERIT: 'inherit',
    ASK: 'ask',
    IGNORE: 'ignore',
};
const SYSTEM_DATA_OBJECT_PERMISSIONS = {
    client: { read: PERMISSIONS.CLIENTS_READ, write: PERMISSIONS.CLIENTS_WRITE },
    deal: { read: PERMISSIONS.DEALS_READ, write: PERMISSIONS.DEALS_WRITE },
    contact: { read: PERMISSIONS.CONTACTS_READ, write: PERMISSIONS.CONTACTS_WRITE },
    action_item: { read: PERMISSIONS.ACTIONS_READ, write: PERMISSIONS.ACTIONS_WRITE },
    product: { read: PERMISSIONS.KNOWLEDGE_BASE_READ, write: PERMISSIONS.KNOWLEDGE_BASE_WRITE },
};
export const DataRecordFilterOperator = {
    EQUALS: 'equals',
    NOT_EQUALS: 'not_equals',
    CONTAINS: 'contains',
    STARTS_WITH: 'starts_with',
    IN: 'in',
    GREATER_THAN: 'greater_than',
    GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
    LESS_THAN: 'less_than',
    LESS_THAN_OR_EQUAL: 'less_than_or_equal',
    IS_EMPTY: 'is_empty',
    IS_NOT_EMPTY: 'is_not_empty',
};
export function isSystemDataObjectKey(value) {
    return SYSTEM_DATA_OBJECT_KEYS.includes(value);
}
export function getDataObjectPermissionId(object, access) {
    if (object.kind === 'custom') {
        return access === 'read' ? PERMISSIONS.CUSTOM_OBJECTS_READ : PERMISSIONS.CUSTOM_OBJECTS_WRITE;
    }
    return isSystemDataObjectKey(object.objectKey)
        ? SYSTEM_DATA_OBJECT_PERMISSIONS[object.objectKey][access]
        : null;
}
export function formatObjectCount(object, count) {
    return `${count} ${count === 1 ? object.labels.singular : object.labels.plural}`;
}
